import { render, staticRenderFns } from "./SendMessageGroupList.vue?vue&type=template&id=c0635cdc&scoped=true&lang=pug"
import script from "./SendMessageGroupList.vue?vue&type=script&lang=ts"
export * from "./SendMessageGroupList.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageGroupList.vue?vue&type=style&index=0&id=c0635cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0635cdc",
  null
  
)

export default component.exports